import { render, staticRenderFns } from "./PerformanceAttributionEdit.vue?vue&type=template&id=0d551eb1&scoped=true&"
import script from "./PerformanceAttributionEdit.vue?vue&type=script&lang=js&"
export * from "./PerformanceAttributionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d551eb1",
  null
  
)

export default component.exports